import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="cs-empty">
      <div className="cs-empty__icon">{icon}</div>
      <h2 className="cs-empty__title">{title}</h2>
      {description && <p className="cs-empty__desc">{description}</p>}
      {action}
    </div>
  );
}
